













import {Component, Watch, Vue} from 'vue-property-decorator'
import {Action, Getter, Mutation} from 'vuex-class'
import {$} from 'simpli-web-sdk'
import * as Config from 'simpli-web-sdk/lib/config'
import ModalImageDisplay from '@/components/modals/ModalImageDisplay.vue'
import ModalBarcodeDisplay from '@/components/modals/ModalBarcodeDisplay.vue'

const metaInfo = () => ({
  title: $.t('app.subtitle'),
  titleTemplate: `%s | ${$.t('app.title')}`,
})

@Component({
  metaInfo,
  components: {ModalBarcodeDisplay, ModalImageDisplay},
})
export default class App extends Vue {
  @Action('auth/onSignIn') onSignIn!: Function
  @Action('auth/onAuth') onAuth!: Function
  @Action('auth/onSignOut') onSignOut!: Function

  @Mutation('auth/POPULATE_TOKEN') populateToken!: Function
  @Mutation('auth/SET_QUERY_TOKEN') setQueryToken!: Function

  toastStyle = Config.ToastDefaultStyle

  // When the user or system signs in
  signInEvent() {
    //
  }

  // When an auth view is accessed successfully
  authEvent() {
    //
  }

  // When the user or system signs out
  signOutEvent() {
    //
  }

  @Watch('$route.path')
  routePathEvent() {
    document.body.style.overflowY = 'unset'
  }

  @Watch('$route', {deep: true, immediate: true})
  async routeEvent() {
    const token = this.$route.query.token as string
    const queryToken = token ? encodeURIComponent(token) : null

    if (this.$route.name === 'tracking') {
      this.setQueryToken(queryToken)
    } else {
      this.setQueryToken(null)
    }
  }

  // Standard Behaviours
  created() {
    this.populateToken()

    const toastConfig = Config.ToastDefaultConfig
    toastConfig.bodyMaxLength = 300

    this.onSignIn(this.signInEvent)
    this.onAuth(this.authEvent)
    this.onSignOut(this.signOutEvent)

    this.$snotify.setDefaults({
      global: Config.ToastGlobalConfig,
      toast: toastConfig,
    })
  }
}
